import { ExtractNodes } from "./ExtractNodes";
import { ExtractPath } from "./ExtractPath";
import { ExtractTikz } from "./ExtractTikz";
import { compoundStates } from "./compoundStates";
export function Tikz2Dot(file) {
  let tikz = file;
  tikz = ExtractTikz(tikz);
  let statesRender = {
    state: "",
    statesRef: "",
    description: "",
    posX: Number,
    posY: Number,
  };
  let transitionRender = {
    stateBegin: "",
    stateDestiny: "",
    statesRef: "",
    label: "",
    description: "",
  };
  var statesArray = [];
  let transit = [];
  statesArray = ExtractNodes(statesRender, statesArray, tikz);
  let transiti = ExtractPath(tikz);
  transiti = compoundStates(transiti, statesArray);
  // BREAKPOINT -> ESTADOS E PROPS
  //let j = 0;
  const regexr = /[^)]+\)/g;
  var transTeste = transiti.match(regexr);
  let initials;
  let finals;
  let labels;
  let descriptions = "";
  let i = 0;
  const regex77 = /\((?!.*\().*$/; // extrai o estado origem da transição
  const regex88 = /{([^}]*)}/; // extrai o símbolo entre {}
  const regex99 = /\[(.*?)\]/; // extrai a descrição da transição
  for (var g = 0; g < transTeste.length; g++) {
    if (transTeste[g].includes("node")) {
      finals = transTeste[g].match(regex77);
      finals = finals ? finals[0].substring(1) : "";
      finals = finals.replace(")", "");
      labels = transTeste[g].match(regex88)[1];
      if (transTeste[g].match(regex99) != null) {
        descriptions = transTeste[g].match(regex99)[1];
      }
    } else {
      initials = transTeste[g].match(regex77);
      initials = initials ? initials[0].substring(1) : "";
      initials = initials.replace(")", "");
      finals = transTeste[g + 1].match(regex77);
      finals = finals ? finals[0].substring(1) : "";
      finals = finals.replace(")", "");
      labels = transTeste[g + 1].match(regex88)[1];
      if (transTeste[g + 1].match(regex99) != null) {
        descriptions = transTeste[g + 1].match(regex99)[1];
        if (descriptions.includes("loop")) {
          finals = initials;
        }
      }
      g++;
    }
    transitionRender = new Object();
    transitionRender.label = labels;
    transitionRender.stateBegin = initials;
    transitionRender.stateDestiny = finals;
    transitionRender.description = descriptions;
    transit[i] = transitionRender;
    if (transit.length > 1) {
      if (
        transit[i - 1].stateBegin == transit[i].stateBegin &&
        transit[i - 1].stateDestiny == transit[i].stateDestiny &&
        (transit[i - 1].description.includes("loop") ||
          transit[i].description.includes("loop"))
      ) {
        finals = initials;
        transitionRender.label = labels;
        transitionRender.stateBegin = initials;
        transitionRender.stateDestiny = finals;
        transitionRender.description = descriptions;
      }
    }
    i++;
  }
  // BREAKPOINT -> TRANSIÇÕES E PROPS
  let dot = "digraph G {";
  let sizeProps = 0;
  dot += "\n";
  let statesString = [];
  let statesProps = [];
  let relativex = 0.0;
  let relativey = 0.0;
  for (let i = 0; i < statesArray.length; i++) {
    statesString[i] = statesArray[i].state.toLowerCase();
    statesString[i] += `[pos="`;
    if (statesArray[i].posX <= 0) {
      statesArray[i].posX = statesArray[i].posX.toFixed(2);
      statesArray[i].posX++;
      while (statesArray[i].posY <= 0) {
        statesArray[i].posY = statesArray[i].posY * -1 + 1;
      }
    }
    if (statesArray[i].posY <= 0) {
      statesArray[i].posY = statesArray[i].posY.toFixed(2);
      statesArray[i].posY++;
      while (statesArray[i].posY <= 0) {
        statesArray[i].posY = statesArray[i].posY * -1 + 1;
      }
    }
    if (statesArray[i].posX > 14) {
      statesArray[i].posX = 14 - relativex;
      relativex = statesArray[i].posX + 1;
    }
    if (statesArray[i].posY > 14) {
      statesArray[i].posX = 14 - relativey;
      relativey = statesArray[i].posY + 1;
    }
    statesArray[i].posX = statesArray[i].posX.toFixed(2);
    statesArray[i].posY = statesArray[i].posY.toFixed(2);
    statesString[i] += statesArray[i].posX += ",";
    statesString[i] += statesArray[i].posY += `"]`;
    if (statesArray[i].description != "state") {
      if (
        /\baccepting\b.*\binitial\b|\binitial\b.*\baccepting\b/.test(
          statesArray[i].description
        )
      ) {
        statesProps[sizeProps] = statesArray[i].state.toLowerCase();
        statesProps[sizeProps] += "[shape=Mdiamond]";
        sizeProps++;
      }
      if (/accepting/.test(statesArray[i].description)) {
        statesProps[sizeProps] = statesArray[i].state.toLowerCase();
        statesProps[sizeProps] += "[shape=square]";
        sizeProps++;
      } else if (/initial/.test(statesArray[i].description)) {
        statesProps[sizeProps] = statesArray[i].state.toLowerCase();
        statesProps[sizeProps] += "[shape=diamond]";
        sizeProps++;
      }
    }
  }
  for (let i = 0; i < statesString.length; i++) {
    dot += statesString[i] += ";\n";
  }
  dot += "\n"; //transições
  let transitionString = [];
  for (let i = 0; i < transit.length; i++) {
    transitionString[i] = transit[i].stateBegin.toLowerCase();
    transitionString[i] += "->";
    transitionString[i] += transit[i].stateDestiny.toLowerCase();
    transitionString[i] += `[label="`;
    if (transit[i].label === "$\\lambda$") {
      transit[i].label = "λ";
    }
    transitionString[i] += transit[i].label;
    transitionString[i] += `"];`;
  }
  for (let i = 0; i < transitionString.length; i++) {
    dot += transitionString[i] += "\n";
  }
  dot += "\n";
  for (let i = 0; i < statesProps.length; i++) {
    dot += statesProps[i] += ";\n";
  }
  if (!transit.length == 0) {
    dot += "\n";
  }
  dot += "}";
  return dot;
}

// começa com \node e termina com ;
